var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadSvg2 = function SvgDownloadSvg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FBC44",
    stroke: "#2FBC44",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M18.43 5.851q-.216.009-.427.008c-3.534 0-5.086-1.59-5.1-1.603l-.382-.424a.7.7 0 0 0-1.04 0l-.39.432.003-.003c-.001-.001-1.638 1.725-5.525 1.59l-.545-.019a.7.7 0 0 0-.724.7v6.81c0 1.16.193 2.638 1.241 4.147 1.042 1.5 2.876 2.955 6.013 4.187l.19.075a.7.7 0 0 0 .512 0l.19-.075c3.137-1.232 4.971-2.687 6.013-4.187 1.048-1.509 1.241-2.987 1.241-4.147v-6.81a.7.7 0 0 0-.724-.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m8.57 13 2.334 2.8 4.666-5.6"
  })));
};
export default SvgDownloadSvg2;